import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=7c2236a6&"
import script from "./CreateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2236a6')) {
      api.createRecord('7c2236a6', component.options)
    } else {
      api.reload('7c2236a6', component.options)
    }
    module.hot.accept("./CreateDialog.vue?vue&type=template&id=7c2236a6&", function () {
      api.rerender('7c2236a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/stream/CreateDialog.vue"
export default component.exports